import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createOrder, fetchAllOrders, updateOrder } from "./OrderAPI";
const initialState = {
  orders: [],
  status: "idle",
  currentOrder: null,
  selectedAddress: null,
  paymentMethod: "cash",
};

export const createOrderAsync = createAsyncThunk(
  "order/createOrder",
  async (order) => {
    const response = await createOrder(order);

    return response.data;
  }
);
export const updateOrderAsync = createAsyncThunk(
  "order/updateOrder",
  async (order) => {
    const response = await updateOrder(order);

    return response.data;
  }
);

export const fetchAllOrdersAsync = createAsyncThunk(
  "order/fetchAllOrders",
  async ({ sort, pagination }, { rejectWithValue }) => {
    try {
      const response = await fetchAllOrders(sort, pagination);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const orderSlice = createSlice({
  name: "order",
  initialState,

  reducers: {
    resetCurrentOrder: (state) => {
      state.currentOrder = null;
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrderAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createOrderAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.orders.push(action.payload);
        state.currentOrder = action.payload;
      })
      .addCase(fetchAllOrdersAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllOrdersAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.orders = action.payload.orders;
        state.totalOrders = action.payload.totalOrders;
      })
      .addCase(fetchAllOrdersAsync.rejected, (state, action) => {
        state.status = "rejected";
        state.orders = [];
      })
      .addCase(updateOrderAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateOrderAsync.fulfilled, (state, action) => {
        state.status = "idle";
        const index = state.orders.findIndex(
          (order) => order.id === action.payload.id
        );
        state.orders[index] = action.payload;
      });
  },
});

export const { resetCurrentOrder, setPaymentMethod, setSelectedAddress } =
  orderSlice.actions;

export const selectOrder = (state) => state.order.currentOrder;
export const selectAddress = (state) => state.order.selectedAddress;
export const selectPaymentMethod = (state) => state.order.paymentMethod;
export const selectOrders = (state) =>
  Array.isArray(state?.order?.orders) ? state.order.orders : [];
export const selectTotalOrders = (state) => state.order.totalOrders;

export default orderSlice.reducer;
